import { render, staticRenderFns } from "./DocGroupsTable.vue?vue&type=template&id=b572afb8&scoped=true&"
import script from "./DocGroupsTable.vue?vue&type=script&lang=js&"
export * from "./DocGroupsTable.vue?vue&type=script&lang=js&"
import style0 from "./DocGroupsTable.vue?vue&type=style&index=0&id=b572afb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b572afb8",
  null
  
)

export default component.exports